import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import commonUtil, { default as CommonUtil } from '../../../common/commonUtil';
import { deleteSaveSearchInfo, registSaveSearchInfo } from '../../../const';
import Const from '../../../const/Const';
// import { deleteFavoriteCondition, getAreaList, getCityListByCountry, getCountryListByArea, setFavoriteCondition, setTempReserveInfo } from "../../../const/RTCC";
import MessageConst from "../../../const/RTCC/messageConst";
import icon_car from '../../../resources/icons/ico_car.svg';
import icon_pin from '../../../resources/icons/ico_location.svg';
import common from '../../../resources/js/common/common';
// import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Image } from "../../atoms/image";
import { Label } from "../../atoms/label";
import { ModalClose } from "../../atoms/modalClose";

const MembershipPopupContainer = (props) => {
    const {
        login,
        toUserInputInfo,
        setReserveInfo,
        setToUserInputInfo,
        setReserveCancelInfo,
        state,
        setPopupMode,
        setPopupMessage,
        onClickClosePopupWindow,
        setMembershipReserveInfo,
        membershipFacility,
        adultNum,
        childNum,
        room,
        planConditions,
        grade,
        food,
        privilegedService,
        setMembershipFacility,
        setAdultNum,
        setChildNum,
        setRoom,
        setPlanConditions,
        setGrade,
        setFood,
        setPrivilegedService,
        setDispDetailCondition,
        setDispFacility, 
        membershipSearchParam,
        setMembershipSearchParam,
        resvKaiinken,
        membershipReserveComf
    } = props;

    const store = useStore();
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupTitle = state.popupTitle;
    const popupMode = state.popupMode;
    const popupMessage = state.popupMessage;
    const contentsType = state.contentsType ? state.contentsType : "";
    let dataList = [];
    let popupData = state.popupData;
    let popupDataList = state.popupDataList;
    let footerClass = "";
    const popupRef = useRef(null);
    moment.locale('ja')

    if (popupMode == 'savedSearch') {
        footerClass = "decision";
        dataList = popupDataList;
    } else if (popupMode == 'message') {
        footerClass = "message"
    } else if (popupMode == 'bookConfirm') {
        footerClass = "reservation";
        dataList = popupDataList;
    } else if (popupMode == 'planDetail') {
        let planDescription = "";
        if (popupData.planDescription) {
            planDescription = popupData.planDescription + (popupData.planTokuten ? "\n" + popupData.planTokuten : "");
        } else {
            planDescription = popupData.planTokuten ? popupData.planTokuten : "";
        }
        footerClass = "hotel";
        dataList = [
            {
                label: popupData.shisetsuName,
                text: "",
                type: "title"
            },
            {
                label: "プラン名",
                text: popupData.planShohinName,
                type: "info"
            },
            {
                label: "プラン内容",
                text: planDescription,
                type: "info"
            },
            {
                label: "案内",
                text: popupData.planAnnaiUrl,
                type: "link"
            },
            {
                label: "その他",
                text: popupData.roomDescription,
                type: "info"
            },
            {
                label: "夕食内容",
                teikyoStartDate: popupData.teikyoStartDate,
                teikyoEndDate: popupData.teikyoEndDate,
                menuName: popupData.menuName,
                image: popupData.courseGazoURL,
                text: popupData.courseNaiyoSetsumeibun1,
                text2: popupData.courseNaiyoSetsumeibun2,
                type: "dinnerInfo"
            },
        ]
    } else if (popupMode == "saveFavorite") {
        footerClass = "saveFavorite";
    } else if (popupMode == "confirmGolf") {
        footerClass = "confirmGolf";
    }
    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);
    useEffect(() => {
        popupRef.current.scrollTop = 0;
        if (document.getElementById("popupText")) {
            let element = document.getElementById("popupText");
            if (contentsType == "conditions") {
                element.style.textAlign = "left";
                element.style.margin = "30px 20px"
            }
            element.innerHTML = CommonUtil.replaceSpecialChar(popupMessage);
        }
    });

    // 決定
    const onClickDecide = () => {
        let resData = state.resData;
        // 施設
        let dispFacility = "";
        let saveShisetsu = resData.shisetsuData ? resData.shisetsuData.split(/\r\n|\n/) : [];
        membershipFacility.membership.forEach(facility => {
            facility.shisetsuList.forEach(data => {
                if (!data.disabled && saveShisetsu.findIndex(shisetsu => shisetsu === data.value) != -1) {
                    data.checked = true;
                    dispFacility = dispFacility + (dispFacility == "" ? "" : ", ");
                    dispFacility = dispFacility + data.value;
                } else {
                    data.checked = false;
                }
            })
        })
        membershipFacility.ippan.forEach(facility => {
            facility.shisetsuList.forEach(data => {
                if (!data.disabled && saveShisetsu.findIndex(shisetsu => shisetsu === data.value) != -1) {
                    data.checked = true;
                    dispFacility = dispFacility + (dispFacility == "" ? "" : ", ");
                    dispFacility = dispFacility + data.value;
                } else {
                    data.checked = false;
                }
            })
        })
        setMembershipFacility({ membership: membershipFacility.membership, ippan: membershipFacility.ippan });
        setDispFacility(dispFacility);
        // ご利用人数
        adultNum.forEach((data) => {
            if (data.id == resData.numberOfAdult) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setAdultNum(adultNum);
        childNum.forEach((data) => {
            if (data.id == resData.numberOfChild) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setChildNum(childNum);
        // 室数
        room.forEach((data) => {
            if (data.id == resData.numberOfRoom) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setRoom(room);
        // 詳細条件
        let dispDetailConditions = "";
        let saveDetailConditions = resData.detailedConditionsList ? resData.detailedConditionsList.split(/\r\n|\n/) : [];
        planConditions.forEach((data) => {
            if (!data.disabled && saveDetailConditions.findIndex(condition => condition === data.value) != -1) {
                data.checked = true;
                dispDetailConditions = dispDetailConditions + (dispDetailConditions == "" ? "" : ", ");
                dispDetailConditions = dispDetailConditions + data.value;
            } else {
                data.checked = false;
            }
        })
        setPlanConditions(planConditions);
        grade.forEach((data) => {
            if (!data.disabled && saveDetailConditions.findIndex(condition => condition === data.value) != -1) {
                data.checked = true;
                dispDetailConditions = dispDetailConditions + (dispDetailConditions == "" ? "" : ", ");
                dispDetailConditions = dispDetailConditions + data.value;
            } else {
                data.checked = false;
            }
        })
        setGrade(grade);
        food.forEach((data) => {
            if (!data.disabled && saveDetailConditions.findIndex(condition => condition === data.value) != -1) {
                data.checked = true;
                dispDetailConditions = dispDetailConditions + (dispDetailConditions == "" ? "" : ", ");
                dispDetailConditions = dispDetailConditions + data.value;
            } else {
                data.checked = false;
            }
        })
        setFood(food);
        privilegedService.forEach((data) => {
            if (!data.disabled && saveDetailConditions.findIndex(condition => condition === data.value) != -1) {
                data.checked = true;
                dispDetailConditions = dispDetailConditions + (dispDetailConditions == "" ? "" : ", ");
                dispDetailConditions = dispDetailConditions + data.value;
            } else {
                data.checked = false;
            }
        })
        setPrivilegedService(privilegedService);
        setDispDetailCondition(dispDetailConditions);
        onClickClosePopupWindow();
    }

    // はい
    const onClickYes = () => {
        if (footerClass === "saveFavorite") {
            // 施設
            let facilities = "";
            membershipFacility.membership.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (item.checked) facilities += facilities === "" ? item.value : "\n" + item.value;
                    })
                }
            });
            membershipFacility.ippan.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (item.checked) facilities += facilities === "" ? item.value : "\n" + item.value;
                    })
                }
            });
            // 1室あたりの人数
            let adults = 2;
            adultNum.forEach((data) => {
                if (data.selected === true) adults = parseInt(data.id);
            });
            let children = 0;
            childNum.forEach((data) => {
                if (data.selected === true) children = parseInt(data.id);
            });
            // 室数
            let roomNum = 1;
            room.forEach((data) => {
                if (data.selected === true) roomNum = parseInt(data.id);
            });
            // 詳細条件
            let detailConditions = "";
            planConditions.forEach((data) => {
                if (data.checked === true) detailConditions += detailConditions === "" ? data.value : "\n" + data.value;
            });
            // grade.forEach((data) => {
            //     if (data.checked === true) detailConditions += detailConditions === "" ? data.value : "\n" + data.value;
            // });
            food.forEach((data) => {
                if (data.checked === true) detailConditions += detailConditions === "" ? data.value : "\n" + data.value;
            });
            privilegedService.forEach((data) => {
                if (data.checked === true) detailConditions += detailConditions === "" ? data.value : "\n" + data.value;
            });
            common.doPost(registSaveSearchInfo, {
                memberCode: login.memberCode,
                shisetsuData: facilities,
                numberOfAdult: adults,
                numberOfChild: children,
                numberOfRoom: roomNum,
                detailedConditionsList: detailConditions,
            }, afterRegistSaveSearchInfo);
        }
    }
    const afterRegistSaveSearchInfo = (res) => {
        let data = res.data;
        if (data.resultCode != 0) {
            setPopupMessage(data.errorMessage);
        } else {
            setPopupMessage(MessageConst.SUCCESS_REGIST);
        }
        setPopupMode("message");
    }

    // 削除
    const onClickDelete = (data) => {
        if (popupMode == 'savedSearch') {
            common.doPost(deleteSaveSearchInfo, { memberCode: login.memberCode }, afterDelete);
        } else if (popupMode == 'reservation') {
            // common.doPost(delReservation, {loginId: loginId}, afterDelete);
        } else if (popupMode == 'bookConfirm') {
            setReserveCancelInfo({
                checkInDate: data.checkInDate,
                checkOutDate: data.checkOutDate,
                hotelId: data.hotelId,
                hotelName: data.hotelName,
                roomId: data.roomId,
                roomName: data.roomName,
                fee: data.fee,
                cancelContents: data.cancelContents,
                paymentId: data.paymentId,
                reserveId: data.reserveId,
                roomList: data.roomList
            });
            history.push("bookingCancelDetail")
        }
    }

    // 予約確認
    const onClickConfirm = (data) => {
        setReserveInfo(data);
        setToUserInputInfo({ ...toUserInputInfo, searchReserveId: null });
        onClickClosePopupWindow();
        history.push("bookingConfirmDetail")
    }

    const afterDelete = (res) => {
        let data = res.data;
        if (data.resultCode != 0) {
            setPopupMessage(data.errorMessage);
        } else {
            setPopupMessage(MessageConst.SUCCESS_DELETE);
        }
        setPopupMode("message");
    }

    // 予約する
    const onClickReserve = () => {
        setMembershipSearchParam({
            ...membershipSearchParam,
            memberCd: resvKaiinken.length? resvKaiinken[0].memberCd : "",
        });
        setMembershipReserveInfo({
            honkanShisetsuCd: popupData.honkanShisetsuCd,
            shisetsuCd: popupData.shisetsuCd,
            shisetsuName: popupData.shisetsuName,
            generalFlg: popupData.generalFlg,
            planShohinCd: popupData.planShohinCd,
            planCd: popupData.planCd,
            planCategoryDetailCd: popupData.planCategoryDetailCd,
            planName: popupData.planName,
            machiFlg: popupData.machiFlg,
            dinnerTsukiPlanFlg: popupData.dinnerTsukiPlanFlg,
            breakfastTsukiPlanFlg: popupData.breakfastTsukiPlanFlg,
            planRyokinTotal: popupData.planRyokinTotal,
            planRyokinAdult: popupData.planRyokinAdult,
            planRyokinChild: popupData.planRyokinChild,
            dinnerRyokinAdult: popupData.dinnerRyokinAdult,
            thanksFlg: popupData.thanksFlg,
            planTokuten: popupData.planTokuten,
            planAnnaiUrl: popupData.planAnnaiUrl,
            changeFlg: state.changeFlg,
            changeType: popupData.changeType,
            yoyakuNo: membershipReserveComf?.yoyakuNo,
        });
        history.push("/reserve/hotel/inputUser");
    }

    const popupBody = dataList ? dataList.map((value, index) => {
        if ((value.text != null && value.text != "") || popupMode == 'savedSearch' || (value.type == "dinnerInfo" && value.image)) {
            if (value.type == "row") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLastSave : style.mobileRowSava}>
                            <div style={style.mobileColHeadingSave}>{value.label}</div>
                            <div style={style.mobileSaveText}>{value.text}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.tableRowSave : style.tableRowSave}>
                            <div style={style.tableColHeadingSave}>{value.label}</div>
                            <div style={style.mobileSaveText}>{value.text}</div>
                        </div>
                    }
                </>
            } else if (value.type == "info") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                            <div style={style.mobileColHeading}>{value.label}</div>
                            <div style={style.tableColBody2}>{value.text}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                            <div style={style.tableColHeadingInfo}>{value.label}</div>
                            <div style={style.tableColBodyHotel}>{value.text}</div>
                        </div>
                    }
                </>
            } else if (value.type == "link") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                            <div style={style.mobileColHeading}>{value.label}</div>
                            <a style={style.tableColBody2} href={value.text} target="_blank" rel="noopener noreferrer">{value.text}</a>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyleUrl}>
                            <div style={style.tableColHeadingInfo}>{value.label}</div>
                            <a style={style.tableColBodyHotel} href={value.text} target="_blank" rel="noopener noreferrer">{value.text}</a>
                        </div>
                    }
                </>
            } else if (value.type == "title") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                            <div style={style.mobileColHeadingTitle}>{value.label}</div>
                            <div style={style.tableColBodyHotel}>{value.text}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                            <div style={style.tableColHeadingTitle}>{value.label}</div>
                            <div style={style.tableColBodyHotel}>{value.text}</div>
                        </div>
                    }
                </>
            } else if (value.type == "dinnerInfo") {
                return <>
                    {isMobilePhone ?
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                            <div style={style.mobileColHeading}>{value.label}</div>
                            <div style={style.tableColBodyCourseNameMobile}>
                                {value?.teikyoStartDate && value.teikyoStartDate != Const.COURSE_START_LIMIT && value?.teikyoEndDate && value.teikyoEndDate != Const.COURSE_END_LIMIT ?
                                    <>
                                        {commonUtil.getStringFromDate(new Date(value.teikyoStartDate), "yyyy.MM.dd") + "-" + commonUtil.getStringFromDate(new Date(value.teikyoEndDate), "yyyy.MM.dd")}
                                        <br />
                                    </>
                                    :
                                    ""
                                }
                                {value.menuName}
                            </div>
                            <div style={style.courseImageWrap}>
                                <Image className="planCourseImage" image={value.image} />
                            </div>
                            <div style={style.tableColBodyCourseInfoMobile}>{value.text}</div>
                            <div style={style.tableColBodyCourseInfoMobile2}>{value.text2}</div>
                        </div>
                        :
                        <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                            <div style={style.tableColHeadingInfo}>{value.label}</div>
                            <div style={style.tableColBodyCourseName}>
                                {value?.teikyoStartDate && value.teikyoStartDate != Const.COURSE_START_LIMIT && value?.teikyoEndDate && value.teikyoEndDate != Const.COURSE_END_LIMIT ?
                                    <>
                                        {commonUtil.getStringFromDate(new Date(value.teikyoStartDate), "yyyy.MM.dd") + "ー" + commonUtil.getStringFromDate(new Date(value.teikyoEndDate), "yyyy.MM.dd")}
                                        <br />
                                    </>
                                    :
                                    ""
                                }
                                {value.menuName}
                            </div>
                            <div style={style.courseImageWrap}>
                                <Image className="planCourseImage" image={value.image} />
                            </div>
                            <div style={style.tableColBodyCourseInfo}>{value.text}</div>
                            <div style={style.tableColBodyCourseInfo2}>{value.text2}</div>
                        </div>
                    }
                </>
            }
        } else if (value.type == "title") {
            return <>
                {isMobilePhone ?
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileTitle}>
                        <div style={style.mobileColHeadingTitle}>{value.label}</div>
                    </div>
                    :
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.tableTitle}>
                        <div style={style.tableColHeadingTitle}>{value.label}</div>
                    </div>
                }
            </>
        } else if (value.type == "location") {
            return <>
                {isMobilePhone ?
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.mobileRow}>
                        <div style={style.mobileColHeading}>{value.label}</div>
                        <div className="addressArea">
                            <img src={icon_pin} style={style.iconPin} />
                            {value.address}
                        </div>
                        <div className={value.access ? "accessArea" : "hiddenItem"}>
                            <img src={icon_car} style={style.iconCar} />
                            {value.access}
                        </div>
                    </div>
                    :
                    <div key={value.type + index} style={index == 0 ? style.mobileRowLast : style.blockStyle}>
                        <div style={style.tableColHeadingInfo}>{value.label}</div>
                        <div className="addressArea">
                            <img src={icon_pin} style={style.iconPin} />
                            {value.address}
                        </div>
                        <div className={value.access ? "accessArea" : "hiddenItem"}>
                            <img src={icon_car} style={style.iconCar} />
                            {value.access}
                        </div>
                    </div>
                }
            </>
        }
    }) : null;

    return (
        <div className={state.membershipPopup ? "popupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={popupMode == "bookConfirm" ? "hiddenItem" : isMobilePhone ? "popupInner_RTCC_media" : "popupInner_RTCC"}>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickClosePopupWindow()} />
                    <h4 className="popupInnerText" >{popupTitle}</h4>
                </div>
                <div style={footerClass == "hotel" ? style.tableRow : style.tableNone} >
                </div>
                {popupMode == "message" || popupMode == "saveFavorite" || popupMode == "confirmGolf" ?
                    <div style={style.messageSave} id="popupText"></div> : <>
                        {footerClass == "hotel" || footerClass == "recommend" ?
                            <div className="popupShisetsuImageWrap">
                                <Image image={popupData.shisetsuImage} className="popupShisetsuImage" />
                            </div>
                            : null}
                        <div style={isMobilePhone ? style.tableMobile : style.table}>
                            {popupBody}
                        </div>
                    </>
                }
                <div style={popupMode == 'savedSearch' ? isMobilePhone ? style.mobileDeleteButton : style.deleteButton : { display: "none" }}>
                    <Button className="conditionDelete" onClick={onClickDelete} buttonClassName="buttonText" buttonText="この条件を削除" />
                </div>
                <div className={footerClass == "decision" ? "buttonArea2" : "hiddenItem"} >
                    <Button className="conditionSearch" onClick={onClickDecide} buttonClassName="buttonText" buttonText="決定" />
                </div>
                <div className={footerClass == "message" ? "buttonArea2" : "hiddenItem"} >
                    <Button className="button" onClick={() => onClickClosePopupWindow()} buttonClassName="buttonText" buttonText="OK" />
                </div>
                <div className={footerClass == "hotel" && popupMode == 'planDetail' ? "buttonArea4" : "hiddenItem"} >
                    <Button className="ReservationButtonModal2" onClick={onClickReserve} buttonText="予約する" />
                </div>
                <div className={footerClass == "reservation" ? "buttonArea2" : "hiddenItem"} >
                    <Button className="reservationConfirmBtn" onClick={onClickConfirm} buttonText="予約内容を確認" />
                    <Button className="reservationDeleteBtn" onClick={onClickDelete} buttonText="予約を取消" />
                </div>
                <div className={footerClass == "saveFavorite" ? "buttonArea2" : "hiddenItem"} style={footerClass == "saveFavorite" ? { display: "flex", alignItems: "center", justifyContent: "center" } : { display: "none" }} >
                    <Button className="reservationConfirmBtn" onClick={onClickYes} buttonText="はい" />
                    <Button className="reservationDeleteBtn" onClick={() => onClickClosePopupWindow()} buttonText="いいえ" />
                </div>
                <div className={footerClass == "confirmGolf" ? "buttonArea2" : "hiddenItem"} style={footerClass == "confirmGolf" ? { display: "flex", alignItems: "center", justifyContent: "center" } : { display: "none" }} >
                    <Button className="reservationConfirmBtn" onClick={onClickYes} buttonText="はい" />
                    <Button className="reservationDeleteBtn" onClick={() => onClickClosePopupWindow()} buttonText="いいえ" />
                </div>
            </div>
            <div className={popupMode == "bookConfirm" ? isMobilePhone ? "popupInner_RTCC_reserveConfirm_media" : "popupInner_RTCC_reserveConfirm" : "hiddenItem"}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickClosePopupWindow()} />
                <h4 className="popupInnerText innerText" >{popupTitle}</h4>
                {popupMode == "bookConfirm" && dataList ? dataList.map((value, index) => {
                    return <div key={"bookConfirm" + index} style={{ background: "#eeeeee96" }}>
                        <div style={style.tableRow2} >
                        </div>
                        <div style={style.message}> {popupMessage}</div>
                        <div style={isMobilePhone ? style.tableMobile : style.table}>
                            <div key={"hotel" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>宿泊ホテル</div>
                                <div style={style.inline}>{value.hotelName}</div>
                            </div>
                            <div key={"checkIn" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>チェックイン</div>
                                <div style={style.inline}>{value.checkInDate}</div>
                            </div>
                            <div key={"checkOut" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>チェックアウト</div>
                                <div style={style.inline}>{value.checkOutDate}</div>
                            </div>
                            <div key={"roomCount" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>室数</div>
                                <div style={style.inline}>{value.roomList.length}</div>
                            </div>
                            <div key={"guestNum" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>1室あたりの人数</div>
                                <div style={style.inline}>{value.roomList[0].ageInfo.length}</div>
                            </div>
                            <div key={"reserveId" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>予約番号</div>
                                <div style={style.inline}>{value.reserveId}</div>
                            </div>
                            <div className="buttonArea3" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <Button className="reservationConfirmBtn" buttonClassName="buttonText" onClick={() => onClickConfirm(value)} buttonText="予約内容を確認" />
                                <Button className="reservationDeleteBtn" buttonClassName="buttonText" onClick={() => onClickDelete(value)} buttonText="予約を取消" />
                            </div>
                        </div>
                    </div>
                }) : <div className="noneReserveWrap"><Label label="現在お預かりしているご予約はありません。" /></div>}
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};
const style = {
    message: {
        // margin: "30px auto",
        whiteSpace: "pre-line",
        textAlign: "center"
    },
    messageSave: {
        margin: "15% 0px",
        whiteSpace: "pre-line",
        textAlign: "center"
    },
    table: {
        display: "block",
        width: "90%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background: "white",
        marginBottom: "0px",
    },
    tableMobile: {
        display: "block",
        width: "90%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background: "white",
        marginBottom: "0px",
    },
    tableTitle: {
        borderTop: "solid 1px rgb(173, 173, 173)"
    },
    tableRowSp: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "block",
        margin: "7px 10px",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    tableRowInfo: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "block",
        fontSize: "15px",
        letterSpacing: "1px",
        margin: "7px 40px",
    },
    tableRowSave: {
        display: "block",
        borderBottom: "1px solid rgb(173, 173, 173)",
        padding: "10px",
        margin: "7px 10px",
        fontSize: "15px",
        letterSpacing: "1px",
        display: "flex",
        alignItems: "center",
    },
    tableRow: {
        display: "table-row",
        borderTop: "solid 1px rgb(173, 173, 173)",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    blockStyle: {
        display: "block",
        borderTop: "solid 1px rgb(173, 173, 173)",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    blockStyleUrl: {
        display: "block",
        borderTop: "solid 1px rgb(173, 173, 173)",
        fontSize: "15px",
        letterSpacing: "1px",
        padding: "0px 0px 20px 0px",
    },
    blockRow: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "table-row",
        fontSize: "15px",
        letterSpacing: "1px",
        margin: "7px 10px",
    },
    tableNone: {
        display: "block",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    tableRow2: {
        padding: "10px",
        display: "block",
        fontSize: "15px",
        letterSpacing: "1px",
    },
    mobileRow: {
        display: "block",
        borderTop: "solid 1px rgb(173, 173, 173)"
    },
    mobileRowSava: {
        display: "block",
        display: "flex",
        alignItems: "center",
        borderTop: "solid 1px rgb(173, 173, 173)"
    },

    tableRowLast: {
        display: "table-row",
    },
    mobileRowLast: {
        display: "block",
    },
    mobileRowLastSave: {
        display: "flex",
        alignItems: "center",
    },
    deleteButton: {
        textAlign: "right",
        margin: "20px calc(5% + 10px) 30px"
    },
    mobileDeleteButton: {
        textAlign: "right",
        width: "90%",
        margin: "0px auto 20px"
    },
    tableColHeading: {
        display: "inline-block",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontSize: "small",
        width: "20%"
    },
    tableColHeadingSave: {
        display: "inline-block",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "20px",
        paddingBottom: "20px",
        fontSize: "small",
        width: "33%"
    },
    tableColHeadingSp: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingBottom: "30px",
        fontSize: "small",
        width: "33%"
    },
    tableColHeadingMob: {
        fontWeight: "bold",
        fontSize: "small",
        marginBottom: "5px"
    },
    inline: {
        display: "inline-block",
        fontSize: "small",
    },
    tableColHeadingInfo: {
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        fontSize: "small",
        width: "80%"
    },
    tableColHeadingTitle: {
        fontWeight: "bold",
        textAlign: "center",
        paddingTop: "30px",
        paddingBottom: "20px",
        fontSize: "large",
        width: "100%",
    },
    mobileColHeadingTitle: {
        fontWeight: "bold",
        textAlign: "center",
        paddingTop: "30px",
        paddingBottom: "20px",
        fontSize: "middle",
        width: "100%",
    },
    mobileColHeading: {
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "30px",
        paddingBottom: "30px",
        fontSize: "small",
        width: "100%"
    },
    mobileColHeadingSave: {
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "15px",
        paddingBottom: "15px",
        fontSize: "small",
        width: "25%"
    },
    mobileSaveText: {
        width: "75%",
        whiteSpace: "pre-line",
        paddingTop: "15px",
        paddingBottom: "15px",
    },
    tableColBody: {
        fontSize: "small",
    },
    tableColBody2: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        color: "black",
    },
    tableColBodyHotel: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        overflowWrap: "anywhere",
        color: "black",
    },
    tableColBodyCourseNameMobile: {
        fontSize: "small",
        fontWeight: "bold",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        color: "black",
        textAlign: "center"
    },
    tableColBodyCourseName: {
        fontSize: "small",
        fontWeight: "bold",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        overflowWrap: "anywhere",
        color: "black",
        textAlign: "center"
    },
    tableColBodyCourseInfoMobile: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        color: "black",
        textAlign: "center"
    },
    tableColBodyCourseInfo: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        overflowWrap: "anywhere",
        color: "black",
        textAlign: "center"
    },
    tableColBodyCourseInfoMobile2: {
        fontSize: "smaller",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        color: "black",
        textAlign: "left"
    },
    tableColBodyCourseInfo2: {
        fontSize: "smaller",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        overflowWrap: "anywhere",
        color: "black",
        textAlign: "left"
    },
    button: {
        width: "100%",
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "15px 120px 15px 120px",
        cursor: "pointer",
    },
    iconPin: {
        width: "24px",
        height: "30px",
        paddingRight: "2px"
    },
    iconCar: {
        width: "24px",
        height: "20px",
        paddingRight: "2px"
    },
    courseImageWrap: {
        textAlign: "center"
    }
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        area: state.area,
        favoriteCondition: state.favoriteCondition,
        reserveInfo: state.reserveInfo,
        toUserInputInfo: state.toUserInputInfo,
        reserveCancelInfo: state.reserveCancelInfo,
        membershipFacility: state.membershipFacility,
        adultNum: state.adultNum,
        childNum: state.childNum,
        room: state.room,
        planConditions: state.planConditions,
        grade: state.grade,
        food: state.food,
        privilegedService: state.privilegedService,
        membershipSearchParam: state.membershipSearchParam,
        resvKaiinken: state.resvKaiinken,
        membershipReserveComf: state.membershipReserveComf,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setFavoriteCondition: (condition) => {
            dispatch({ type: "FAVORITE_CONDITION", payload: { favoriteCondition: condition } });
        },
        setReserveInfo: (item) => {
            dispatch({ type: "RESERVE_INFO", payload: { reserveInfo: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setReserveCancelInfo: (item) => {
            dispatch({ type: "RESERVE_CANCEL_INFO", payload: { reserveCancelInfo: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipPopupContainer);
